module.exports = __webpack_public_path__ + "static/img/404.ae5bf10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404.svg
// module id = 761
// module chunks = 0